export default "__VITE_ASSET__Cg3AY3ID__"